import { CheckOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import Text from 'shared/components/typography/Text'
import { OptionType } from '../../../types'
import s from './s.module.css'
import Icon from '@/shared/components/Icon'

export type Props = OptionType & {
  isSelected?: boolean
  onClick?: () => void
  iconBadgeSrc?: string
  icon?: string
  iconSize?: number
}

export default function Option({ icon, code, name, isSelected, onClick, iconBadgeSrc, iconSize = 32 }: Props) {
  return (
    <Flex gap={10} flex={1} align="center" className={s.option} onClick={onClick}>
      <Icon iconSrc={icon} iconBadgeSrc={iconBadgeSrc} code={code} iconSize={iconSize} lazy />
      <Flex gap={4} align="center">
        <Text fontType="body" fontSize={14} type="primary">
          {code}
        </Text>
        <Text fontType="description" color="var(--grey-500)">
          {name}
        </Text>
      </Flex>
      {isSelected && (
        <div className={s.check}>
          <CheckOutlined style={{ color: 'var(--accent-light)' }} />
        </div>
      )}
    </Flex>
  )
}
